const prefix = "SCHEDULED_JOB_";

export const DELETE_INITIALISE = prefix + "DELETE_INITIALISE";
export const EDIT_DELETE_FAILED = prefix + "EDIT_DELETE_FAILED";
export const EDIT_DELETE_STARTED = prefix + "EDIT_DELETE_STARTED";
export const EDIT_DELETE_SUCCEEDED = prefix + "EDIT_DELETE_SUCCEEDED";
export const EDIT_GET_FAILED = prefix + "EDIT_GET_FAILED";
export const EDIT_GET_STARTED = prefix + "EDIT_GET_STARTED";
export const EDIT_GET_SUCCEEDED = prefix + "EDIT_GET_SUCCEEDED";
export const EDIT_INITIALISE_FOR_CREATE = prefix + "EDIT_INITIALISE_FOR_CREATE";
export const EDIT_SAVE_FAILED = prefix + "EDIT_SAVE_FAILED";
export const EDIT_SAVE_STARTED = prefix + "EDIT_SAVE_STARTED";
export const EDIT_SAVE_SUCCEEDED = prefix + "EDIT_SAVE_SUCCEEDED";
export const EDIT_SET_DATA = prefix + "EDIT_SET_DATA";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const RUN_FAILED = prefix + "RUN_FAILED";
export const RUN_INITIALISE = prefix + "RUN_INITIALISE";
export const RUN_OVERDUE_FAILED = prefix + "RUN_OVERDUE_FAILED";
export const RUN_OVERDUE_INITIALISE = prefix + "RUN_OVERDUE_INITIALISE";
export const RUN_OVERDUE_STARTED = prefix + "RUN_OVERDUE_STARTED";
export const RUN_OVERDUE_SUCCEEDED = prefix + "RUN_OVERDUE_SUCCEEDED";
export const RUN_STARTED = prefix + "RUN_STARTED";
export const RUN_SUCCEEDED = prefix + "RUN_SUCCEEDED";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const VIEW_CLEAR = prefix + "VIEW_CLEAR";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_NEXT = prefix + "VIEW_NEXT";
export const VIEW_PREVIOUS = prefix + "VIEW_PREVIOUS";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
